import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { default as ReactDateTimePicker } from 'react-widgets/DatePicker'
import DropdownList from 'react-widgets/DropdownList'
import { DateLocalizer } from 'react-widgets/IntlLocalizer'
import Localization from 'react-widgets/Localization'
import 'react-widgets/styles.css'
import { generateDate } from 'client/components/core/Sidebar/components/Settings/entities/Countdown/utils/date-time-utils'
import { OptionWrapper } from 'src/editor/layout/sidebar/settings/option-wrapper'
import { getDefaultTime, timeOptions } from './utils'

interface DateTimePickerProps {
  dateTime: Date
  updateDate: (date: Date) => void
  showDate?: boolean
}

const DateTimePicker = ({
  updateDate,
  dateTime,
  showDate = true,
}: DateTimePickerProps) => {
  const { i18n } = useTranslation()
  const fallbackLng = i18n.options.fallbackLng
    ? (i18n.options.fallbackLng as string[])[0]
    : 'en'
  const language = i18n.language || fallbackLng

  const [time, setTime] = useState<string>(getDefaultTime(dateTime, language))
  const [date, setDate] = useState<Date>(dateTime)

  return (
    <OptionWrapper>
      <Localization
        date={
          new DateLocalizer({
            culture: language,
            firstOfWeek: 1,
          })
        }
      >
        <div style={{ display: 'flex' }}>
          {showDate && (
            <div style={{ marginRight: '5px' }}>
              <ReactDateTimePicker
                containerClassName="[&>.rw-input]:h-10!"
                lang={language}
                calendarProps={{ view: 'month' }}
                defaultValue={dateTime}
                onChange={date => {
                  if (date) {
                    setDate(date)
                    updateDate(generateDate({ date, time }))
                  }
                }}
              />
            </div>
          )}
          <div style={showDate ? { width: '60%' } : { width: '100%' }}>
            <DropdownList
              className="h-full"
              containerClassName="h-full"
              data={timeOptions(language)}
              onChange={time => {
                setTime(time)
                updateDate(generateDate({ date, time }))
              }}
              defaultValue={time}
            />
          </div>
        </div>
      </Localization>
    </OptionWrapper>
  )
}
export default DateTimePicker
